<div class="modal-header">
    <h4 class="modal-title">Registrar Nuevo Cliente</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
    <form [formGroup]="form">
        <div class="row">
            <div class="form-group col-12 col-sm-12">
                <label for="email">Correo Electrónico</label>
                <input type="email" class="form-control" id="email" formControlName="email"
                    [ngClass]="{'is-invalid': form.controls['email'].errors && (form.controls['email'].dirty || form.controls['email'].touched)}">
                <div class="invalid-feedback">
                    Debe ingresar un valor en el campo
                </div>
                <div class="invalid-feedback" *ngIf=" form.controls['email'].errors?.['email']">
                    El correo electrónico no es válido.
                </div>
                <div class="mb-4"
                    *ngIf="!form.controls['email'].errors || !(form.controls['email'].dirty || form.controls['email'].touched)">
                </div>
            </div>
        </div>

        <div class="row">
            <div class="form-group col-12 col-sm-6">
                <label for="nombre">Nombre</label>
                <input type="text" class="form-control" id="nombre" formControlName="nombre"
                    [ngClass]="{'is-invalid': form.controls['nombre'].errors && form.controls['nombre'].touched}">
                <div class="invalid-feedback">
                    Debe ingresar un valor en el campo
                </div>
                <div class="mb-4" *ngIf="!form.controls['nombre'].errors || !form.controls['nombre'].touched">
                </div>
            </div>
            <div class="form-group col-12 col-sm-6">
                <label for="apellido">Apellido</label>
                <input type="text" class="form-control" id="apellido" formControlName="apellido"
                    [ngClass]="{'is-invalid': form.controls['apellido'].errors && form.controls['apellido'].touched}">
                <div class="invalid-feedback">
                    Debe ingresar un valor en el campo
                </div>
                <div class="mb-4" *ngIf="!form.controls['apellido'].errors || !form.controls['apellido'].touched">
                </div>
            </div>
        </div>

        <div class="row">
            <div class="form-group col-12 col-sm-6">
                <label for="rut">RUT</label><label class="campo-opcional"> (Opcional)</label>
                <input type="text" class="form-control" id="rut" formControlName="rut" (keyup)="changed_rut($event)"
                    [ngClass]="{'is-invalid': form.controls['rut'].errors && form.controls['rut'].touched}">
                <div class="invalid-feedback"
                    *ngIf="form.controls['rut'].errors && form.controls['rut'].errors['rutInvalido']">
                    El Rut ingresado no es válido.
                </div>
                <div class="mb-4" *ngIf="!form.controls['rut'].errors || !form.controls['rut'].touched">
                </div>
            </div>
            <div class="form-group col-12 col-sm-6">
                <label for="fono">Teléfono</label><label class="campo-opcional"> (Opcional)</label>
                <input type="text" class="form-control" id="fono" formControlName="fono">
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="guardar()">Registrar</button>
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('Cancel click')">Cancelar</button>
</div>